import * as React from 'react';
import { getColorValue } from '../utilities/color';

function PlayMediaGreyscale(props) {
  const fill = getColorValue('illustrationGreyscaleFill');
  const accent = getColorValue('illustrationGreyscaleAccent');
  const mid = getColorValue('illustrationGreyscaleMidDark');

  return (
    <svg fill="none" height="196" viewBox="0 0 196 196" width="196" {...props}>
      <path
        d="M139.665 73.5398C136.336 55.016 123.471 43.6053 105.425 40.6688C102.346 40.1699 99.1176 39.9133 95.7607 39.9133C92.4037 39.9133 88.8971 40.1913 85.6969 40.7258C67.6436 43.7407 54.8002 55.1301 51.4647 73.5469C50.9016 76.6615 50.6094 79.9686 50.6094 83.4752C50.6094 86.9818 50.8945 90.2034 51.4504 93.2752C54.7574 111.671 67.6151 123.081 85.6969 126.096C88.8971 126.631 92.254 126.909 95.7607 126.909C99.2673 126.909 102.346 126.652 105.425 126.153C123.5 123.217 136.379 111.778 139.679 93.2823C140.228 90.2105 140.513 86.9391 140.513 83.4823C140.513 80.0256 140.221 76.6616 139.665 73.5541V73.5398Z"
        fill={fill}
      />
      <path
        d="M79.3314 109.248L79.2031 70.3899L116.244 89.6977L79.3314 109.248Z"
        fill={mid}
      />
      <path
        d="M83.0736 102.833L82.9453 63.9822L119.979 83.2828L83.0736 102.833Z"
        fill={accent}
      />
      <path d="M159.566 148.996V141.969H37.0628V148.996H159.566Z" fill={fill} />
      <path
        d="M75.0353 142.076C74.1515 137.136 70.7162 134.093 65.9124 133.316C65.0927 133.181 64.2303 133.117 63.3394 133.117C62.4485 133.117 61.5077 133.188 60.6596 133.331C55.8487 134.136 52.4204 137.172 51.5367 142.076C51.387 142.902 51.3086 143.786 51.3086 144.72C51.3086 145.654 51.387 146.509 51.5295 147.328C52.4133 152.232 55.8344 155.275 60.6596 156.074C61.5148 156.216 62.4058 156.287 63.3394 156.287C64.2731 156.287 65.0927 156.216 65.9124 156.088C70.7304 155.304 74.1658 152.253 75.0424 147.328C75.1921 146.509 75.2634 145.639 75.2634 144.72C75.2634 143.8 75.185 142.902 75.0353 142.076Z"
        fill={accent}
      />
      <path
        d="M51.5289 142.076C51.3792 142.902 51.3008 143.786 51.3008 144.72C51.3008 145.654 51.3792 146.516 51.5217 147.328C51.6286 147.913 51.7712 148.462 51.9422 148.989H74.6212C74.7923 148.462 74.9348 147.906 75.0417 147.328C75.1914 146.509 75.2627 145.639 75.2627 144.72C75.2627 143.8 75.1843 142.902 75.0346 142.076C75.0346 142.04 75.0203 142.004 75.0132 141.969H51.5502C51.5502 142.004 51.536 142.04 51.5289 142.076Z"
        fill={mid}
      />
    </svg>
  );
}

export default PlayMediaGreyscale;
